// Bundle entry. Executes after the 21 pristine scripts and before the inline
// bootstrap's load() — the position that lets extracted modules shim pristine
// globals before any save is loaded.

import {
  legacyWindow,
  replaceGlobal,
  restoreGlobal,
  installedShims,
  installWindowBridge,
  installedBridges,
} from './strangler'
import { timeStopped, bigFinishPoint, magicHardcap, platinumUpgrade6Effect } from './transients/index'
import { isDevVersion } from './config'
import { buildRegistry, adoptCachedBoxes, uiElement, uiFamily, uiNames, uiFamilyList } from './ui/registry'
import { exposeGlobal, exposedGlobals } from './strangler'
import * as formulas from './engine/formulas'
import { computeDerived, sections, liveCtx, SECTION_ORDER } from './engine/tick'
import { createInitialState, SAVE_KEYS } from './engine/state'
import { createFlags, serializeFlags, deserializeFlags } from './engine/flags'
import {
  loadPipeline, saveGame, serializeSave, deserializeSave,
  browserStorage, QUARANTINE_KEY,
} from './engine/save/pipeline'

// Promote the shared transients: bare-identifier access in pristine code now
// resolves through these module-owned boxes (seeded from the values the
// pristine top-level code already set).
installWindowBridge('timeStopped', timeStopped)
installWindowBridge('bigFinishPoint', bigFinishPoint)
installWindowBridge('magicHardcap', magicHardcap)
installWindowBridge('platinumUpgrade6Effect', platinumUpgrade6Effect)
installWindowBridge('isDevVersion', isDevVersion)

// Stable DOM addressing: resolve every data-ui element and verify the
// registry agrees element-for-element with the positional order the legacy
// sites use. (As of step 6 the bundle loads BEFORE script.js — the engine is
// the state factory at parse time — so anything that needs a later pristine
// script defers to lateInit, called by the index.html bootstrap.)
buildRegistry(document)

/** Post-scripts init: runs from the bootstrap line, after render.js. */
function lateInit(): void {
  adoptCachedBoxes()
}

// Canonical formulas (step 5): the redirected pristine call sites resolve
// them through this one published global.
exposeGlobal('__engine', {
  magifolds: formulas.magifolds,
  magicHardcapValue: formulas.magicHardcapValue,
  minerCost: formulas.minerCost,
  minerCostBase: formulas.minerCostBase,
  knowledgeTradeReward: formulas.knowledgeTradeReward,
  knowledgeTradeRewardPreview: formulas.knowledgeTradeRewardPreview,
  knowledgeUpgrade2EffectValue: formulas.knowledgeUpgrade2EffectValue,
  upgradeCost: formulas.upgradeCost,
  // Step 6: the live state factory — site reset()'s literal redirects here.
  createInitialState,
  // Step 7a: the save pipeline — site loadGame/save/export/import redirect here.
  loadPipeline: (loadgame: Record<string, any>, game: any) => loadPipeline(loadgame, game, () => Date.now(), browserStorage()),
  saveGame: (game: any) => saveGame(game, browserStorage(), () => Date.now()),
  serializeSave,
  deserializeSave: (raw: string) => deserializeSave(raw, browserStorage()),
  QUARANTINE_KEY,
})

legacyWindow.__remaster = {
  step: 7,
  lateInit,
  replaceGlobal,
  restoreGlobal,
  installedShims,
  installedBridges,
  transients: { timeStopped, bigFinishPoint, magicHardcap, platinumUpgrade6Effect, isDevVersion },
  ui: { uiElement, uiFamily, uiNames, uiFamilyList },
  engine: {
    formulas, computeDerived, sections, liveCtx, SECTION_ORDER,
    createInitialState, SAVE_KEYS,
    flags: { createFlags, serializeFlags, deserializeFlags },
  },
  exposedGlobals,
}
